import { Component, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MaskitoDirective } from '@maskito/angular';
import { maskitoTransform } from '@maskito/core';
import {
  maskitoDateOptionsGenerator,
  maskitoNumberOptionsGenerator,
} from '@maskito/kit';
import { DadosTabelaPqrPadraoProfessoresDto, PQRFormacaoJornadaRemuneracaoProfessoresDto} from '../../dtos';

@Component({
  selector: 'app-dialog-pqr-padrao-numero-de-dias',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MaskitoDirective,
    NgFor,
    TabelaComponent,
  ],
  templateUrl: './dialog-pqr-padrao-professores.component.html',
  styleUrl: './dialog-pqr-padrao-professores.component.scss',
})

export class DialogPqrPadraoProfessoresComponent {
  @Input() dadosTabela: PQRFormacaoJornadaRemuneracaoProfessoresDto[] = [];
  dadosTabelaViewModel: DadosTabelaPqrPadraoProfessoresDto[] = [];

  mask_porcetagem_inteira = maskitoNumberOptionsGenerator({
    postfix: ' %',
    min: 0,
    max: 100,
    precision: 1,
    decimalSeparator: ',',
    decimalZeroPadding: true,
  });

  mask_dinheiro = maskitoNumberOptionsGenerator({
    prefix: 'R$ ',
    decimalSeparator: ',',
    decimalZeroPadding: true,
    precision: 2,
  });

  mask_mes_ano = maskitoDateOptionsGenerator({
    mode: 'mm/yyyy',
    separator: '/',
  });

  constructor() { }

  ngOnInit() {
    this.dadosTabelaViewModel = this.transformDadosTabela(this.dadosTabela);
  }

  transformDadosTabela(dadosTabela: PQRFormacaoJornadaRemuneracaoProfessoresDto[]): DadosTabelaPqrPadraoProfessoresDto[] {
    return dadosTabela.map((item) => {
      return {
        seqDenominacao: item.denominacao,
        idNivelFormacao: item.tipoNivelFormacao.codTipoNivelFormacao,
        descricaoNivelFormacao: item.tipoNivelFormacao.descricao,
        totalJornadaTrabalho: item.jornadaTotal,
        porcentSemInteracaoEducando: maskitoTransform(String(item.jornadaSemInteracao), this.mask_porcetagem_inteira),
        porcentComInteracaoEducando: maskitoTransform(String(item.jornadaComInteracao), this.mask_porcetagem_inteira),
        remuneracaoBruta: maskitoTransform(String(item.remuneracaoBrutaMensal), this.mask_dinheiro),
        mesAnoRef: item.mesAnoReferencia.split('-').reverse().join('/')
      }
    });
  }
}
